export const routes = {
  root: "/",

  submission: {
    view: "/submissions/:id/",
  },

  students: {
    list: "/students/",
    view: "/students/:id/",
  },

  pageNotFound: "/*",
} as const
